export const GET_MEASURE_ENGAGEMENT_WATCHER =
  "app/EngagementMeasurement/GET_MEASURE_ENGAGEMENT_WATCHER"
export const GET_MEASURE_ENGAGEMENT_SUCCESS =
  "app/EngagementMeasurement/GET_MEASURE_ENGAGEMENT_SUCCESS"
export const GET_MEASURE_ENGAGEMENT_FAILED =
  "app/EngagementMeasurement/GET_MEASURE_ENGAGEMENT_FAILED"
export const GET_DIMENSIONS_DATA_WATCHER = "app/EngagementMeasurement/GET_DIMENSIONS_DATA_WATCHER"
export const GET_DIMENSIONS_DATA_SUCCESS = "app/EngagementMeasurement/GET_DIMENSIONS_DATA_SUCCESS"  
export const GET_DIMENSIONS_DATA_FAILED = "app/EngagementMeasurement/GET_DIMENSIONS_DATA_FAILED"